import { Component, OnInit } from '@angular/core';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { DiarioComponent } from '../diario/diario.component';
import { Router } from '@angular/router';
import { GatewayService } from 'src/app/gateway.service';
import { BusquedaService } from 'src/app/home/busqueda.service';
import { Subscription } from 'rxjs/Subscription';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { PasswordnewComponent } from 'src/app/login/passwordnew/passwordnew.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-monitorcampanas',
  templateUrl: './monitorcampanas.component.html',
  styleUrls: ['./monitorcampanas.component.scss']
})
export class MonitorcampanasComponent implements OnInit {
  private destroy$ = new Subject<void>();

  campanaColumns: string[] = [
                                'CAMPANA', 
                                'AGENTEDISPONIBLE', 
                                'BACKOFFICE', 
                                'ALMUERZO', 
                                'CAPACITACION', 
                                'BANO', 
                                'OTROS', 
                                // 'VPH', 
                                'CONTACTABILIDAD', 
                                // 'CONVERSION', 
                                // 'EFECTIVIDAD', 
                                'ACCION'
                              ];
  dataSource = new MatTableDataSource<any>([]);
  interval;

  private subscription: Subscription;
  private filtrocampana = '';

  constructor(
    private spinner: NgxSpinnerService,
    public pageTitle: ComponentPageTitle,
    private dialog: MatDialog,
    private router: Router,
    private _busqueda: BusquedaService,
    private gateway: GatewayService,
    private localsave: LocalSaveService

  ) { }

  ngOnInit() {
    this.loadCampana();
    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrocampana = res.filtro;
        this.loadCampana();
      });

    this.interval = setInterval(()=>{
      this.refrescar();
    },60000)

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    clearInterval(this.interval);
  }

  ngAfterViewInit(){
    if (this.localsave.get('nuevoUserPass') === 0){
      setTimeout(() => {
        this.openPassword();  
      })
      
    }
  }

  loadCampana() {
    this.spinner.show();
    this.gateway.get('supervisorcampana', { FILTRO: this.filtrocampana, IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU }).then((result: any) => {
      this.dataSource = new MatTableDataSource(result.rows);
      this.spinner.hide();
    }
    ).catch(function (e) {
    });
  }

  refrescar() {
    this.loadCampana();
  }

  diario(campana) {
    this.localsave.set('supervisorcampana', campana);
    this.router.navigate(['home/diariocampana'])
      .then((e) => {
        this.spinner.hide();
      });
  }

  horas(campana) {
    this.localsave.set('supervisorcampana', campana);
    this.router.navigate(['home/horascampana'])
      .then((e) => {
        this.spinner.hide();
      });
  }

  agentes(campana) {
    this.localsave.set('supervisorcampana', campana);
    this.router.navigate(['home/agentescampana'])
      .then((e) => {
        this.spinner.hide();
      });
  }

  rellamada(campana) {
    this.localsave.set('supervisorcampana', campana);
    this.router.navigate(['home/rellamadacampana'])
      .then((e) => {
        this.spinner.hide();
      });
  }

  descargaExcel(){

    let datareport = [];
    clearInterval(this.interval);
    this.spinner.show();
    this.gateway.get('supervisorcampana', { FILTRO: this.filtrocampana, IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU }).then((result: any) => {
      datareport = result.rows;

      datareport.forEach(function(currentItem) {
        delete currentItem['idcampana'];
        Object.defineProperty(currentItem, 'Disponibles',Object.getOwnPropertyDescriptor(currentItem, 'agentesdisponibles')); 
        delete currentItem['agentesdisponibles'];

        Object.defineProperty(currentItem, 'Backoffice',Object.getOwnPropertyDescriptor(currentItem, 'agentesbackoffice')); 
        delete currentItem['agentesbackoffice'];
        
        Object.defineProperty(currentItem, 'Almuerzo',Object.getOwnPropertyDescriptor(currentItem, 'agentesalmuerzo')); 
        delete currentItem['agentesalmuerzo'];

        Object.defineProperty(currentItem, 'Capacitación',Object.getOwnPropertyDescriptor(currentItem, 'agentescapacitacion')); 
        delete currentItem['agentescapacitacion'];

        Object.defineProperty(currentItem, 'Baño',Object.getOwnPropertyDescriptor(currentItem, 'agentesbano')); 
        delete currentItem['agentesbano'];        

        Object.defineProperty(currentItem, 'Otros',Object.getOwnPropertyDescriptor(currentItem, 'agentesotros')); 
        delete currentItem['agentesotros'];        

        Object.defineProperty(currentItem, 'VPH',Object.getOwnPropertyDescriptor(currentItem, 'vph')); 
        delete currentItem['vph'];

        Object.defineProperty(currentItem, 'Contactabilidad',Object.getOwnPropertyDescriptor(currentItem, 'contactabilidad')); 
        delete currentItem['contactabilidad'];

        Object.defineProperty(currentItem, 'Conversion',Object.getOwnPropertyDescriptor(currentItem, 'conversion')); 
        delete currentItem['conversion'];

        Object.defineProperty(currentItem, 'Efectividad',Object.getOwnPropertyDescriptor(currentItem, 'efectividad')); 
        delete currentItem['efectividad'];
      });
    //  console.log(datareport)
      const fileName = 'Monitor_campañas_' + Date.now();
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(datareport);
      XLSX.utils.book_append_sheet(wb, ws);

      const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
      this.spinner.hide();
      this.interval = setInterval(()=>{
        this.refrescar();
      },60000)
    }
    ).catch(function (e) {
    });

  }

  public async openPassword() {
    const agente = this.localsave.get('usuarioPGV');
    let dialogRef = await this.dialog.open(PasswordnewComponent, {
      width: '450px',
      disableClose: true,
      data: { title: 'Cambio de contraseña', agente:{idagente:agente.IDU}}
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

}
